import React, { useState, useEffect, useContext } from 'react'
import AppContext from '../../../contexts/AppContext'
import { Link } from 'react-router-dom'
import moment from "moment"
import Header from '../../Header'
import Breadcrumbs from '../../Breadcrumbs'
import Footer from '../../Footer'
import { breadcrumbsBy } from '../../../services/locations'
import { userNameFrom, avatarFrom } from '../../../services/users'
import { searchFromHash } from '../../../services/search'
import Pagination from "react-js-pagination";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'

import { Helmet } from "react-helmet-async";

const ThreadItem = ({ thread }) => {

    const { data } = useContext(AppContext)
    const user = data?.app?.user

    if(!user) return null

    const hasParticipant = thread.participants?.filter(item => item.user_id != user?.id).length > 0
    const participant = hasParticipant
        ? thread.participants?.filter(item => item.user_id != user?.id)[0].user
        : thread.participants[0].user

    const hasMParticipant = thread.participants?.filter(item => item.user_id == thread?.latest_message?.user_id).length > 0
    const mParticipant = hasMParticipant
        ? thread.participants?.filter(item => item.user_id == thread?.latest_message?.user_id)[0].user
        : null

    const newMessages = thread.new_messages
    const image = thread.threadable?.meta?.image?.urls
        ? thread.threadable.meta.image?.urls['100_100_crop']
        : (
            thread.threadable?.data?.images?.length > 0
            ? thread.threadable?.data?.images[0]
            : null
        )

    const avatar = avatarFrom(participant)
    const userName = userNameFrom(participant)

    const mAvatar = avatarFrom(mParticipant)
    const mUserName = userNameFrom(mParticipant)

    const isThreadableWatched = thread.threadable?.is_watched && user.type == 'admin'
    const isUserWatched = participant?.is_watched && user.type == 'admin'
    const isMUserWatched = mParticipant?.is_watched && user.type == 'admin'

    const type = thread.threadable_type?.replace('App\\', '')

    return (
        <Link
            to={`/account/messages/${thread.id}`}
            aria-current="true"
            className={'list-group-item list-group-item-action' + (newMessages > 0 ? ' bg-light' : '')}
        >
            <div className="d-flex w-100 justify-content-between">
                <div className="d-flex justify-content-start">
                    <div className="me-3">
                        <img
                            className="avatar-img"
                            alt={userName}
                            src={avatar}
                        />
                    </div>
                    <div className="me-2">
                        <h6 className="font-weight-bold mb-1">
                            {userName ? userName : 'Deleted user'}
                            {newMessages > 0 && <span className="ms-2 badge bg-danger rounded-pill">{newMessages}</span>}
                            {isUserWatched && <span className="ms-2 badge bg-danger rounded-pill">User Watched</span>}
                        </h6>
                        {thread.latest_message ? (
                            <>
                                <p className="mb-1">
                                    {mParticipant &&
                                        <>
                                            <span className="me-2">
                                                <img
                                                    className="avatar-img-18"
                                                    alt={mUserName}
                                                    src={mAvatar}
                                                />
                                            </span>
                                            <span className="me-2">
                                                <b>{mUserName}:</b>
                                            </span>
                                        </>
                                    }
                                    <span>{thread.latest_message.body}</span>
                                    {isMUserWatched && <span className="ms-2 badge bg-danger rounded-pill">User Watched</span>}
                                </p>
                                <small>{moment(thread.latest_message.created_at).fromNow()}</small>
                            </>
                        ) : (
                            <p className="mb-1 text-muted">
                                No messages found
                            </p>
                        )}
                    </div>
                </div>
                <div>
                    <div>
                        {image ? (
                            <img
                                width="75"
                                alt={thread.threadable.title}
                                title={thread.threadable.title}
                                src={image}
                            />
                        ) : (
                            <div className="small card-img-bg no-image text-center"><i className="fa fa-camera"></i></div>
                        )}
                    </div>
                    <div className="text-center" style={{width: '75px'}}>
                        <div><small>{type}</small></div>
                    </div>

                    {isThreadableWatched && <span className="ms-2 badge bg-danger rounded-pill">Watched</span>}
                </div>
            </div>
        </Link>
    )
}

const Threads = ({ search }) => {

    const [ threads, setThreads ] = useState([])
    const [ page, setPage ] = useState(1)
    const [ loading, setLoading ] = useState(false)

    const { messageServices } = useContext(AppContext)
    const hasSearch = Object.keys(search).length > 0

    const loadThreads = () => {
        setLoading(true)
        messageServices.index(search, page).then(res => {
            setThreads(res.threads)
            setLoading(false)
        }).catch(err => {
            console.log(err)
            setLoading(false)
        })
    }

    useEffect(() => {
        loadThreads()
    }, [ hasSearch, page ])

    return (
        <>
            <div className="list-group mb-3">

                {threads.data?.length == 0 &&
                    <div className="alert alert-info">You have no messages at this time.</div>
                }

                {threads.data && threads.data.map(thread =>
                    <ThreadItem
                        key={thread.id}
                        thread={thread}
                    />
                )}
            </div>

            <div className="d-flex">
                {threads.data && threads.data.length > 0 && threads.last_page > 1 &&
                    <nav>
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={parseInt(threads.per_page)}
                            totalItemsCount={threads.total}
                            pageRangeDisplayed={5}
                            onChange={setPage}
                            itemClass="page-item"
                            linkClass="page-link"
                            prevPageText="Previous"
                            nextPageText="Next"
                            hideFirstLastPages={true}
                        />
                    </nav>
                }
            </div>

        </>
    )
}


const Messages = ({ match, history }) => {

    const { location } = useContext(AppContext)
    const [ search, setSearch ] = useState(searchFromHash())
    const hasSearch = Object.keys(search).length > 0
    const unread =  Object.keys(search).filter(item => item == 'unread').length > 0
    const breadcrumbs = [
        {url: '/account', title: 'Dashboard'},
        ...(hasSearch ? [{url: '/account/messages', title: 'Inbox'}, {title: 'Filtered'}] : [{title: 'Inbox'}])
    ];

    return (
        <>
            <div>
                <Header history={history} fluid={true} />
                <main className="py-4">
                    <div className="container-fluid">
                        <div className="container">
                            <div className='d-flex justify-content-between'>
                                <Breadcrumbs list={breadcrumbsBy(location, breadcrumbs)} />
                                <div>
                                    <button
                                        className={'btn btn-sm btn-' + (unread ? 'primary active' : 'outline-primary')}
                                        onClick={() => setSearch(unread ? {} : {...search, unread: !unread})}
                                    >
                                        <FontAwesomeIcon icon={faFilter} />
                                        <span className="ms-2">Unread</span>
                                    </button>
                                </div>
                            </div>

                            <Helmet><title>{'Messages | ' + process.env.MIX_APP_NAME}</title></Helmet>

                            <Threads search={search} />
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </>
    )
}

export default Messages
